import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
  CircularProgress,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Paper,
  TableContainer,
  Table,
} from "@mui/material";
import { format, parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  retrieveAllOrdersApi,
  retrieveFilteredOrdersApi,
} from "../../../components/api/OrderApiService";
import { retrieveShipmentRequestByIdApi, updateShipmentRequestApi } from "../../../components/api/ShipmentRequestApiService";
import { retrieveUsersApi } from "../../../components/api/UserApiService";
import { retrieveFilteredShippingInstructionsApi, retrieveShippingInstructionByIdApi } from "../../../components/api/ShippingInstructionApiService";
import { retrieveFilteredWarehouseRecordsApi } from "../../../components/api/WarehouseApiService";
import { retrieveFastStakeholdersApi, retrieveStakeholderByIdApi } from "../../../components/api/StakeholderApiService";
import SearchIcon from "@mui/icons-material/Search";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";
import FilterSelect from "../../../components/FilterSelect";

const EditShipmentRequest = (props) => {
  const { rows, setRows, editShipmentRequest, setEditShipmentRequest, mapShipmentRequest } = props;
  const [loading, setLoading] = useState(true);

  const [orders, setOrders] = useState([]);
  const [selectedPo, setSelectedPo] = useState(null);
  const [selectedSo, setSelectedSo] = useState(null);
  const [stakeholders, setStakeholders] = useState([]);
  const [selectedStakeholder, setSelectedStakeholder] = useState("");
  const { addViewStates } = props;
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [shippingInstructions, setShippingInstructions] = useState([]);
  const [selectedSi, setSelectedSi] = useState(null);

  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const [openPoDialog, setOpenPoDialog] = useState(false);
  const [openSoDialog, setOpenSoDialog] = useState(false);

      useEffect(() => {
      retrieveShipmentRequestByIdApi(editShipmentRequest?.data?.id)
           .then((response) => {
             setEditShipmentRequest({visible: true, data: response?.data});
             setLoading(false);
           })
           .catch((error) => {console.log(error.response?.data);
            setLoading(false);
           })
      }, []);
  
      useEffect(() => {
        if (!loading && editShipmentRequest?.data) {
          const data = editShipmentRequest.data;
          setSelectedPo(data?.purchaseOrder || null);
          setSelectedSo(data?.salesOrder || null);
          setSelectedStakeholder(data?.shipmentRequestTo || "");
          setSelectedUser(data?.assignedUser || null); 
          setFilterShippingInstruction(prev => ({
            ...prev,
            purchaseOrderIdList: data?.purchaseOrder?.id ? [data.purchaseOrder.id] : []
          }));
          retrieveShippingInstructionByIdApi(data?.referenceShippingInstructionId)
          .then((response) => {
            setSelectedSi(response?.data);
          })
          .catch((error) => {console.log(error.response?.data);
          })
        }
      }, [loading, editShipmentRequest]);

  function retrieveOrders(orderType) {
    retrieveAllOrdersApi(orderType)
      .then((response) => {
        setOrders(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  const determineDestination = (incoterm, portOfLoading, portOfDischarge) => {
    const incotermsUsingPortOfLoading = ["EXW", "FCA", "FAS", "FOB"];
    const incotermsUsingPortOfDischarge = ["CFR", "C&F", "CIF", "CPT", "CIP", "DAP", "DPU", "DDP"];
  
    const safeIncoterm = incoterm || "";
  
    if (incotermsUsingPortOfLoading.includes(safeIncoterm)) {
      return `${safeIncoterm} ${portOfLoading || ""}`;
    } else if (incotermsUsingPortOfDischarge.includes(safeIncoterm)) {
      return `${safeIncoterm} ${portOfDischarge || ""}`;
    }
    return ""; 
  };

  const filterWarehouse = {
    recordStatusList: ["ACTIVE"],
  };

    function retrieveStakeholders() {
      Promise.all([
        retrieveFastStakeholdersApi("VENDOR"),
        retrieveFastStakeholdersApi("CUSTOMER"),
      ])
        .then(([vendorResponse, customerResponse]) => {
          setStakeholders([...vendorResponse?.data, ...customerResponse?.data]);
        })
        .catch((error) => console.log(error.response?.data));
    }

  function retrieveFilteredWarehouseRecords(filterWarehouse) {
    retrieveFilteredWarehouseRecordsApi(filterWarehouse)
      .then((response) => {
        setWarehouses(response?.data)
        return response?.data || [];
      })
      .catch((error) => console.log(error.response?.data));
  }

  const [filterShippingInstruction, setFilterShippingInstruction] = useState({
    id: 0,
    shipmentRequestIdList: [],
    freightOfferIdList: [],
    purchaseOrderIdList: editShipmentRequest?.data?.purchaseOrder?.id ? [editShipmentRequest.data.purchaseOrder.id] : [],
    shippingInstructionTypeList: ["FVTW", "FVTWCT", "FVTWZF", "FWTW", "FWTWCT", "FWTWZF"],
    salesOrderIdList:[],
    transportationContact: "",
    cartonNumber: "",
    finalShippingInstructionNumber:"",
    shippedByList: [],
    billOfLadingNumber: "",
    cmrNumber: "",
    shipperIdList: [],
    consigneeIdList: [],
    notifyIdList: [],
    pointOfLoadingList: [],
    pointOfUnloadingList: [],
    description: "",
    remark: "",
    statusList: ["Open","Closed"],
    recordStatusList: ["ACTIVE"],
  });

  function retrieveFilteredShippingInstructions(filterShippingInstruction) {
    retrieveFilteredShippingInstructionsApi(filterShippingInstruction)
      .then((response) => {
        setShippingInstructions(response?.data)
        return response?.data || [];
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveFilteredOrders(orderDto) {
    retrieveFilteredOrdersApi(orderDto)
      .then((response) => {
        setOrders(response?.data);
        return response?.data || [];
      })
      .catch((error) => console.log(error.response?.data));
  }
  function retrieveUsers() {
    retrieveUsersApi()
      .then((response) => {
          setUsers(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const orderDto = {
    orderType: "",
    offerId: addViewStates?.offer?.id,
    offerIdList: [] || [],
    itemIdList: [],
    stakeholderIdList: [],
    costIdList: [],
    companyList: [],
    approvalStatusList: ["Approved"],
    orderStatusList: [],
    customerList: [],
    firstSampleIdList: [],
    secondSampleIdList: [],
    firstSampleStatusList: [],
    secondSampleStatusList: [],
    paymentTermList: [],
    incotermList: [],
    portOfLoadingList: [],
    portOfDischargeList: [],
    packagingList: [],
    volumeUnitList: [],
    firstPriceCurrencyList: [],
    finalPriceCurrencyList: [],
    documentStatusList: [],
    originList: [],
    typeList: [],
    leafFormList: [],
    colorList: [],
    storageList: [],
    recordStatusList: ["ACTIVE"],
  };
  return (
    <>
         {loading ? (
        <div>Loading...</div>
      ) : (
        <>
      <Stack direcion="column">
        <Typography variant="h2" mb={2}>
          Edit Shipment Request {editShipmentRequest?.data?.id} {editShipmentRequest?.data?.shipmentRequestType}
        </Typography>
        <Grid container item xs={12} spacing="8px">
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Select Purchase Order</Typography>
            <Autocomplete
              options={orders || []}
              getOptionLabel={(option) =>
                `ID: ${option?.id || ""}, SAP PO Number: ${
                  option?.purchaseOrderNumber || ""
                }, Vendor: ${option?.stakeholder?.name || ""},
                  Item ID: ${option?.offer?.item?.id || ""}
                  , Grade: ${option?.offer?.item?.buyingGrade || ""},
                   Origin: ${option?.offer?.item?.origin || ""},
                   Crop: ${option?.offer?.item?.crop || ""}`
              }
              value={selectedPo}
              onChange={(event, newValue) => {
                setSelectedPo(newValue);
                setFilterShippingInstruction({...filterShippingInstruction, purchaseOrderIdList: [selectedPo?.id] });
                setSelectedSi(null);
                setSelectedStakeholder(newValue?.stakeholder);
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    purchaseOrder: newValue ? newValue : null,
                    shipmentRequestTo: newValue?.stakeholder?.name || "",
                  },
                });
              }}
              onOpen={() => {
                if (selectedSo?.id) {
                  orderDto.orderType = "VENDOR";
                  orderDto.itemIdList = [selectedSo?.offer?.item?.id];
                  orderDto.approvalStatusList = ["Approved"];
                  orderDto.recordStatusList = ["ACTIVE"];
                  retrieveFilteredOrders(orderDto);
                } else {
                  orderDto.orderType = "VENDOR";
                  orderDto.approvalStatusList = ["Approved"];
                  orderDto.recordStatusList = ["ACTIVE"];
                  retrieveFilteredOrders(orderDto);
                }
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label={`${selectedPo?.id || ""}`}
                />
              )}
              renderTags={() => null}
            />
            {selectedPo && (
              <Box mt={2}>
                <Chip
                  label={`ID: ${selectedPo?.id || ""}`}
                  onDelete={() => {
                    setSelectedPo(null);
                    setEditShipmentRequest({
                      ...editShipmentRequest,
                      data: {
                        ...editShipmentRequest.data,
                        purchaseOrder: {},
                      },
                    });
                  }}
                  style={{ marginBottom: "5px" }}
                />{" "}
                <br></br>
                <Chip
                  label={`SAP PO Number: ${
                    selectedPo?.purchaseOrderNumber || ""
                  }`}
                  style={{ marginBottom: "5px" }}
                />
                <br></br>
                <Chip
                  label={`Quantity: ${selectedPo?.volume || ""} ${
                    selectedPo?.volumeUnit || ""
                  }`}
                  style={{ marginBottom: "5px" }}
                />
                <br></br>
                <Chip
                  label={`Supplier: ${
                    selectedPo?.offer?.stakeholder?.name || ""
                  }`}
                  style={{ marginBottom: "5px" }}
                />
                <br></br>
                <Chip
                  label={`Item ID: ${selectedPo?.offer?.item?.id || ""}`}
                  style={{ marginBottom: "5px" }}
                />
                <br></br>
              </Box>
            )}
                {selectedPo && (
      <Tooltip title="View Details">
        <IconButton onClick={() => setOpenPoDialog(true)}>
          <SearchIcon />
        </IconButton>
      </Tooltip>
    )}
          </Grid>

<Dialog open={openPoDialog} onClose={() => setOpenPoDialog(false)} maxWidth="md" fullWidth>
  <DialogTitle sx={{
    bgcolor: "#1976d2",
    color: "#fff",
    fontWeight: 700,
    fontSize: 22,
    letterSpacing: 1,
    textAlign: "center",
    borderBottom: "2px solid #1890ff"
  }}>
    Purchase Order Details
  </DialogTitle>
  <DialogContent sx={{ bgcolor: "#f9fafb", p: 3 }}>
    {selectedPo ? (
      <Box sx={{
        background: "#fff",
        borderRadius: 2,
        boxShadow: 2,
        p: 2,
        maxWidth: "1000px",
        mx: "auto"
      }}>
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          General Info
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ID:</Typography><Typography variant="body1">{selectedPo?.id}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Year:</Typography><Typography variant="body1">{selectedPo?.orderYear}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>SAP PO Number:</Typography><Typography variant="body1">{selectedPo?.purchaseOrderNumber}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Group Number:</Typography><Typography variant="body1">{selectedPo?.orderGroupNumber}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Contract Value Date:</Typography><Typography variant="body1">{selectedPo?.contractValueDate ? format(parseISO(selectedPo?.contractValueDate), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Vendor:</Typography><Typography variant="body1">{selectedPo?.offer?.stakeholder?.name}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>SAP Vendor Code:</Typography><Typography variant="body1">{selectedPo?.offer?.stakeholder?.code}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Company:</Typography><Typography variant="body1">{selectedPo?.company}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Status:</Typography><Typography variant="body1">{selectedPo?.orderStatus}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Record Status:</Typography><Typography variant="body1">{selectedPo?.recordStatus}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Issue Date:</Typography><Typography variant="body1">{selectedPo?.operationDate ? format(parseISO(selectedPo?.operationDate), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={12}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Contract Link:</Typography><Typography variant="body1">{selectedPo?.contractLink}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Offer & Item Details
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Offer:</Typography><Typography variant="body1">{selectedPo?.offer?.id} - {selectedPo?.offer?.offerYear} - {selectedPo?.offer?.offerGroupNumber}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Buying Grade:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.buyingGrade}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Internal Grade:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.internalGrade}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Sales Grade:</Typography><Typography variant="body1">{selectedPo?.salesGrade}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Origin:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.origin}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Province:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.province}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Crop:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.crop}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Nicotine:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.nicotine}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Sugar:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.sugar}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Moisture:</Typography><Typography variant="body1">{selectedPo?.offer?.item?.moisture}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Quantity & Pricing
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Net Weight Per Carton:</Typography><Typography variant="body1">{selectedPo?.netWeightPerCase}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Number Of Cartons:</Typography><Typography variant="body1">{selectedPo?.numberOfCases}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Volume:</Typography><Typography variant="body1">{selectedPo?.volume} {selectedPo?.volumeUnit}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Packaging:</Typography><Typography variant="body1">{selectedPo?.packaging}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Final Price:</Typography><Typography variant="body1">{selectedPo?.finalPrice} {selectedPo?.finalPriceCurrency}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Total Amount:</Typography><Typography variant="body1">{selectedPo?.totalAmount}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Terms & Logistics
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Incoterm:</Typography><Typography variant="body1">{selectedPo?.incoterm}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Payment Term:</Typography><Typography variant="body1">{selectedPo?.paymentTerm}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Port Of Discharge:</Typography><Typography variant="body1">{selectedPo?.portOfDischarge}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Port Of Loading:</Typography><Typography variant="body1">{selectedPo?.portOfLoading}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ETD:</Typography><Typography variant="body1">{selectedPo?.estimatedTimeOfDeparture ? format(parseISO(selectedPo?.estimatedTimeOfDeparture), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ETA:</Typography><Typography variant="body1">{selectedPo?.estimatedTimeOfArrival ? format(parseISO(selectedPo?.estimatedTimeOfArrival), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Shipment Schedule:</Typography><Typography variant="body1">{selectedPo?.shipmentSchedule}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Shipping Term:</Typography><Typography variant="body1">{selectedPo?.shippingTerm}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Sample & Notes
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Redrawn Sample:</Typography>
            <Typography variant="body1">
              {selectedPo.firstSample
                ? `ID: ${selectedPo.firstSample.id}, Remark: ${selectedPo.firstSample.remark}, Buying Grade: ${selectedPo.firstSample.item?.buyingGrade}`
                : ""}
            </Typography>
          </Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Redrawn Sample Status:</Typography>
            <Typography variant="body1">{selectedPo.firstSampleStatus}</Typography>
          </Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Remark:</Typography>
            <Typography variant="body1">{selectedPo.remark}</Typography>
          </Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Comment:</Typography>
            <Typography variant="body1">{selectedPo.comment}</Typography>
          </Grid>
        </Grid>
      </Box>
    ) : null}
  </DialogContent>
</Dialog>

          {(editShipmentRequest?.data?.shipmentRequestType === "FWTC" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTIMP" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTW" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTWCT" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTWZF" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTINW") && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Select SI</Typography>
              <Autocomplete
                options={shippingInstructions || []}
                getOptionLabel={(option) =>
                  `ID: ${option?.id || ""}, SI Number: ${option?.finalShippingInstructionNumber || ""}, SR : ${option?.shipmentRequest?.shipmentRequestType || ""}, SR Number: ${option?.shipmentRequest?.id || ""}, Date: ${option?.stakeholder?.name || ""}, POD: ${option?.pointOfUnloading|| ""}`
                }
                value={selectedSi}
                onChange={(event, newValue) => {
                  setSelectedSi(newValue);
                  setEditShipmentRequest({
                    ...editShipmentRequest,
                    data: {
                      ...editShipmentRequest.data,
                      referenceShippingInstructionId: newValue ? newValue.id : "",
                      referenceShippingInstructionNumber: newValue ? newValue.finalShippingInstructionNumber : "",
                      warehouse: newValue ? newValue?.destination : "",
                    },
                  });
                  if (newValue) {
                    const filterWarehouse = {
                      recordStatusList:["ACTIVE"],
                      warehouseList:[newValue?.destination]
                    }
                    retrieveFilteredWarehouseRecordsApi(filterWarehouse)
                      .then((warehouseInfo) => {
                        console.log("warehouseInfo", warehouseInfo?.data[0]);
                        setEditShipmentRequest((prevData) => ({
                          ...prevData,
                          data: {
                            ...prevData.data,
                            shipmentRequestTo: warehouseInfo?.data[0]?.contactPerson?.name,
                          },
                        }));
                        setSelectedStakeholder(warehouseInfo?.data[0]?.contactPerson);
                      })
                      .catch((error) => {
                        console.error("Error fetching warehouse info:", error);
                      });
                  }
                }}
                onOpen={() => retrieveFilteredShippingInstructions(filterShippingInstruction)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                    label={`${editShipmentRequest?.data?.referenceShippingInstructionId || ""} - ${editShipmentRequest?.data?.referenceShippingInstructionNumber || ""}`}
                  />
                )}
                renderTags={() => null}
              />
              {selectedSi && (
                <Box mt={2}>
                  <Chip
                    label={`ID: ${selectedSi?.id || ""}`}
                    onDelete={() => {
                      setSelectedSi(null);
                      setEditShipmentRequest({
                        ...editShipmentRequest,
                        data: {
                          ...editShipmentRequest.data,
                          referenceShippingInstructionNumber: "", 
                          referenceShippingInstructionId: "", 
                        },
                      });
                    }}
                    style={{ marginBottom: "5px" }}
                  />{" "}
                  <br></br>
                </Box>
              )}
            </Grid>
          )}

{(editShipmentRequest?.data?.shipmentRequestType === "FWTC" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTIMP" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTW" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTWCT" ||
                        editShipmentRequest?.data?.shipmentRequestType === "FWTWZF" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTC" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTINW") && (editShipmentRequest?.data?.referenceShippingInstructionNumber ||selectedSi) && (
<Grid item xs={12} sm={2}>
            <Typography variant="body2">Warehouse</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              disabled
              id="outlined-select-pol"
              value={selectedSi?.destination}
            >
            </TextField>
          </Grid>
            )}

          {(editShipmentRequest?.data?.shipmentRequestType === "FWTC" ||
          editShipmentRequest?.data?.shipmentRequestType === "FWTWCT" ||
          editShipmentRequest?.data?.shipmentRequestType === "FVTWCT" ||
                    editShipmentRequest?.data?.shipmentRequestType === "FWTWZF" ||
          editShipmentRequest?.data?.shipmentRequestType === "FVTWZF" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTIMP" ||
            editShipmentRequest?.data?.shipmentRequestType === "FVTC" ||
            editShipmentRequest?.data?.shipmentRequestType === "FVTIMP") && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Select Sales Order</Typography>
              <Autocomplete
                options={orders || []}
                getOptionLabel={(option) =>
                  `ID: ${option?.id || ""}, SAP SO Number: ${
                    option?.salesOrderNumber || ""
                  }, Customer: ${option?.offer?.stakeholder?.name || ""}, 
                  Item ID: ${option?.offer?.item?.id || ""},
                  Buying Grade: ${option?.offer?.item?.buyingGrade || ""},
                  Sales Grade: ${option?.offer?.salesGrade || ""},
                   Origin: ${option?.offer?.item?.origin || ""},
                   Crop: ${option?.offer?.item?.crop || ""}`
                }
                value={selectedSo}
                onChange={(event, newValue) => {
                  setSelectedSo(newValue);
                  const shouldUpdateDestination =
                  editShipmentRequest?.data?.shipmentRequestType === "FWTC" ||
                  editShipmentRequest?.data?.shipmentRequestType === "FVTC";

                const newDestination = shouldUpdateDestination
                  ? determineDestination(
                      newValue?.incoterm || "",
                      editShipmentRequest?.data?.portOfLoading,
                      editShipmentRequest?.data?.portOfDischarge
                    )
                  : editShipmentRequest?.data?.destination; 

                  setEditShipmentRequest({
                    ...editShipmentRequest,
                    data: {
                      ...editShipmentRequest.data,
                      salesOrder: newValue ? newValue : null,
                    destination: newDestination,
                    portOfLoading: newValue?.portOfLoading ? newValue.portOfLoading : "",
                    portOfDischarge: newValue?.portOfDischarge ? newValue.portOfDischarge : "",
                      customerGradeMark: newValue
                        ? newValue?.offer?.salesGrade
                        : "",
                      productionTobaccoCode: newValue
                        ? newValue?.offer?.item?.tobaccoCode
                        : "",
                    },
                  });
                }}
                onOpen={() => {
                  if (selectedPo?.id) {
                    orderDto.orderType = "CUSTOMER";
                    orderDto.itemIdList = [selectedPo?.offer?.item?.id];
                    orderDto.approvalStatusList = ["Approved"];
                    orderDto.recordStatusList = ["ACTIVE"];
                    retrieveFilteredOrders(orderDto);
                  } else {
                    orderDto.orderType = "CUSTOMER";
                    orderDto.approvalStatusList = ["Approved"];
                    orderDto.recordStatusList = ["ACTIVE"];
                    retrieveFilteredOrders(orderDto);
                  }
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                    label={`${selectedSo?.id || ""}`}
                  />
                )}
                renderTags={() => null}
              />
              {selectedSo && (
                <Box mt={2}>
                  <Chip
                    label={`ID: ${selectedSo?.id || ""}`}
                    onDelete={() => {
                      setSelectedSo(null);
                      setEditShipmentRequest({
                        ...editShipmentRequest,
                        data: {
                          ...editShipmentRequest.data,
                          salesOrder: {},
                        },
                      });
                    }}
                    style={{ marginBottom: "5px" }}
                  />{" "}
                  <br></br>
                  <Chip
                    label={`SAP SO Number: ${
                      selectedSo?.salesOrderNumber || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Quantity: ${selectedSo?.volume || ""} ${
                      selectedSo?.volumeUnit || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Customer: ${
                      selectedSo?.offer?.stakeholder?.name || ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                       label={`Customer Grade Mark: ${selectedSo?.offer?.salesGrade || ""}`}
                       style={{ marginBottom: '5px' }}
                     /><br></br>
                  <Chip
                    label={`Item ID: ${selectedSo?.offer?.item?.id || ""}`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                </Box>
              )}
               {selectedSo && (
                <Tooltip title="View Details">
                  <IconButton onClick={() => setOpenSoDialog(true)}>
                    <SearchIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
          )}

<Dialog open={openSoDialog} onClose={() => setOpenSoDialog(false)} maxWidth="md" fullWidth>
  <DialogTitle sx={{
    bgcolor: "#232f3e",
    color: "#fff",
    fontWeight: 700,
    fontSize: 22,
    letterSpacing: 1,
    textAlign: "center",
    borderBottom: "2px solid #1976d2"
  }}>
    Sales Order Details
  </DialogTitle>
  <DialogContent sx={{ bgcolor: "#f9fafb", p: 3 }}>
    {selectedSo ? (
      <Box sx={{
        background: "#fff",
        borderRadius: 2,
        boxShadow: 2,
        p: 2,
        maxWidth: "1000px",
        mx: "auto"
      }}>
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          General Info
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ID:</Typography><Typography variant="body1">{selectedSo.id}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Year:</Typography><Typography variant="body1">{selectedSo.orderYear}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>SAP SO Number:</Typography><Typography variant="body1">{selectedSo.salesOrderNumber}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Group Number:</Typography><Typography variant="body1">{selectedSo.orderGroupNumber}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Contract Value Date:</Typography><Typography variant="body1">{selectedSo.contractValueDate ? format(parseISO(selectedSo.contractValueDate), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Customer:</Typography><Typography variant="body1">{selectedSo.offer?.stakeholder?.name}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>SAP Customer Code:</Typography><Typography variant="body1">{selectedSo.offer?.stakeholder?.code}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Company:</Typography><Typography variant="body1">{selectedSo.company}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Order Status:</Typography><Typography variant="body1">{selectedSo.orderStatus}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Record Status:</Typography><Typography variant="body1">{selectedSo.recordStatus}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Issue Date:</Typography><Typography variant="body1">{selectedSo.operationDate ? format(parseISO(selectedSo.operationDate), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={12}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Contract Link:</Typography><Typography variant="body1">{selectedSo.contractLink}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Offer & Item Details
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Offer:</Typography><Typography variant="body1">{selectedSo.offer?.id} - {selectedSo.offer?.offerYear} - {selectedSo.offer?.offerGroupNumber}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Buying Grade:</Typography><Typography variant="body1">{selectedSo.offer?.item?.buyingGrade}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Internal Grade:</Typography><Typography variant="body1">{selectedSo.offer?.item?.internalGrade}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Sales Grade:</Typography><Typography variant="body1">{selectedSo.salesGrade}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Origin:</Typography><Typography variant="body1">{selectedSo.offer?.item?.origin}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Province:</Typography><Typography variant="body1">{selectedSo.offer?.item?.province}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Crop:</Typography><Typography variant="body1">{selectedSo.offer?.item?.crop}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Nicotine:</Typography><Typography variant="body1">{selectedSo.offer?.item?.nicotine}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Sugar:</Typography><Typography variant="body1">{selectedSo.offer?.item?.sugar}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Moisture:</Typography><Typography variant="body1">{selectedSo.offer?.item?.moisture}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Quantity & Pricing
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Net Weight Per Carton:</Typography><Typography variant="body1">{selectedSo.netWeightPerCase}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Number Of Cartons:</Typography><Typography variant="body1">{selectedSo.numberOfCases}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Volume:</Typography><Typography variant="body1">{selectedSo.volume}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Unit:</Typography><Typography variant="body1">{selectedSo.volumeUnit}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Packaging:</Typography><Typography variant="body1">{selectedSo.packaging}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Final Price:</Typography><Typography variant="body1">{selectedSo.finalPrice}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Currency:</Typography><Typography variant="body1">{selectedSo.finalPriceCurrency}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Total Amount:</Typography><Typography variant="body1">{selectedSo.totalAmount}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Terms & Logistics
        </Typography>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Incoterm:</Typography><Typography variant="body1">{selectedSo.incoterm}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Payment Term:</Typography><Typography variant="body1">{selectedSo.paymentTerm}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Port Of Discharge:</Typography><Typography variant="body1">{selectedSo.portOfDischarge}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Port Of Loading:</Typography><Typography variant="body1">{selectedSo.portOfLoading}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ETD:</Typography><Typography variant="body1">{selectedSo.estimatedTimeOfDeparture ? format(parseISO(selectedSo.estimatedTimeOfDeparture), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>ETA:</Typography><Typography variant="body1">{selectedSo.estimatedTimeOfArrival ? format(parseISO(selectedSo.estimatedTimeOfArrival), "yyyy-MM-dd") : ""}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Shipment Schedule:</Typography><Typography variant="body1">{selectedSo.shipmentSchedule}</Typography></Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Shipping Term:</Typography><Typography variant="body1">{selectedSo.shippingTerm}</Typography></Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#1976d2", mb: 2, fontWeight: 700 }}>
          Sample & Notes
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Redrawn Sample:</Typography>
            <Typography variant="body1">
              {selectedSo.firstSample
                ? `ID: ${selectedSo.firstSample.id}, Remark: ${selectedSo.firstSample.remark}, Buying Grade: ${selectedSo.firstSample.item?.buyingGrade}`
                : ""}
            </Typography>
          </Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Redrawn Sample Status:</Typography>
            <Typography variant="body1">{selectedSo.firstSampleStatus}</Typography>
          </Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Remark:</Typography>
            <Typography variant="body1">{selectedSo.remark}</Typography>
          </Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Comment:</Typography>
            <Typography variant="body1">{selectedSo.comment}</Typography>
          </Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Description Of Goods:</Typography>
            <Typography variant="body1">{selectedSo.descriptionOfGoods}</Typography>
          </Grid>
          <Grid item xs={6}><Typography variant="body2" sx={{ fontWeight: 600, color: "#555" }}>Customer Reference:</Typography>
            <Typography variant="body1">{selectedSo.customerReference}</Typography>
          </Grid>
        </Grid>
      </Box>
    ) : null}
  </DialogContent>
</Dialog>
          {(selectedSo || selectedPo) && (
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Item</Typography>
              <TextField
                disabled
                type="number"
                variant="outlined"
                size="small"
                fullWidth
                value={
                  selectedSo?.offer?.item?.id ||
                  selectedPo?.offer?.item?.id ||
                  ""
                }
              />
              {(selectedSo || selectedPo) && (
                <Box mt={2}>
                  <Chip
                    label={`ID: ${
                      selectedSo?.offer?.item?.id ||
                      selectedPo?.offer?.item?.id ||
                      ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />{" "}
                  <br></br>
                  <Chip
                    label={`Origin: ${
                      selectedSo?.offer?.item?.origin ||
                      selectedPo?.offer?.item?.origin ||
                      ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Type: ${
                      selectedSo?.offer?.item?.type ||
                      selectedPo?.offer?.item?.type ||
                      ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Buying Grade: ${
                      selectedSo?.offer?.item?.buyingGrade ||
                      selectedPo?.offer?.item?.buyingGrade ||
                      ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Sales Grade: ${
                      selectedSo?.offer?.item?.salesGrade ||
                      selectedPo?.offer?.item?.salesGrade ||
                      ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Crop: ${
                      selectedSo?.offer?.item?.crop ||
                      selectedPo?.offer?.item?.crop ||
                      ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                  <Chip
                    label={`Storage: ${
                      selectedSo?.offer?.item?.storage ||
                      selectedPo?.offer?.item?.storage ||
                      ""
                    }`}
                    style={{ marginBottom: "5px" }}
                  />
                  <br></br>
                </Box>
              )}
            </Grid>
          )}

                    {(editShipmentRequest?.data?.shipmentRequestType === "FWTC" ||
                      editShipmentRequest?.data?.shipmentRequestType === "FVTC" ||
          editShipmentRequest?.data?.shipmentRequestType === "FWTWCT" ||
          editShipmentRequest?.data?.shipmentRequestType === "FVTWCT" ||
                    editShipmentRequest?.data?.shipmentRequestType === "FWTWZF" ||
          editShipmentRequest?.data?.shipmentRequestType === "FVTWZF" ||
          editShipmentRequest?.data?.shipmentRequestType === "FWTW" ||
          editShipmentRequest?.data?.shipmentRequestType === "FVTW" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTIMP" ||
            editShipmentRequest?.data?.shipmentRequestType === "FWTINW" ||
            editShipmentRequest?.data?.shipmentRequestType === "FVTIMP" ||
            editShipmentRequest?.data?.shipmentRequestType === "FVTINW") && (
                      <Grid item xs={12} sm={2}>
                        <Typography variant="body2">SI To</Typography>
                        <Autocomplete
                          options={stakeholders}
                          getOptionLabel={(option) =>
                            `${option.id || ""} - ${option.type || ""} - ${
                              option.name || ""
                            }`
                          }
                          onChange={(event, newValue) => {
                            setSelectedStakeholder(newValue);
                            setEditShipmentRequest({
                              ...editShipmentRequest,
                              data: {
                                ...editShipmentRequest.data,
                                shipmentRequestTo: newValue ? newValue?.name : null,
                              },
                            })
                          }}
                          onOpen={retrieveStakeholders}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              size="small"
                              fullWidth
                              disabled={
                                addViewStates?.shipmentRequestType === "FVTC" ||
                                addViewStates?.shipmentRequestType === "FVTW" ||
                                addViewStates?.shipmentRequestType === "FVTWCT" ||
                                addViewStates?.shipmentRequestType === "FVTWZF" ||
                                addViewStates?.shipmentRequestType === "FVTP" ||
                                addViewStates?.shipmentRequestType === "FVTIMP" ||
                                addViewStates?.shipmentRequestType === "FVTINW"
                              }
                              label={editShipmentRequest?.data?.shipmentRequestTo}
                            />
                          )}
                          renderTags={() => null}
                        />
                        {selectedStakeholder && (
                          <Box mt={2}>
                            <Chip
                              label={`ID: ${selectedStakeholder?.id || ""}`}
                              style={{ marginBottom: "5px" }}
                              onDelete={() => setSelectedStakeholder(null)}
                            />
                            <br />
                            <Chip
                              label={`Type: ${selectedStakeholder?.type || ""}`}
                              style={{ marginBottom: "5px" }}
                            />
                            <br />
                            <Chip
                              label={`Name: ${selectedStakeholder?.name || ""}`}
                              style={{ marginBottom: "5px" }}
                            />
                            <br />
                          </Box>
                        )}
                      </Grid>
                    )}

         {/*{( editShipmentRequest?.data?.shipmentRequestType === "FWTIMP" ||
                editShipmentRequest?.data?.shipmentRequestType === "FWTINW" ||
                editShipmentRequest?.data?.shipmentRequestType === "FVTIMP" ||
                editShipmentRequest?.data?.shipmentRequestType === "FVTINW") && (
                  <Grid item xs={12} sm={2}>
                <Typography variant="body2">Production Tobacco Code</Typography>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={editShipmentRequest?.data?.productionTobaccoCode}
                  onChange={(e) =>
                    setEditShipmentRequest({
                      ...editShipmentRequest,
                      data: {
                        ...editShipmentRequest.data,
                        productionTobaccoCode: e.target.value,
                      },
                    })
                  }
                />
              </Grid>
             )}*/}
             
           <Grid item xs={12} sm={2}>
            <Typography variant="body2">Customer Grade Mark</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={editShipmentRequest?.data?.customerGradeMark}
              onChange={(e) =>
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    customerGradeMark: e.target.value,
                  },
                })
              }
            />
          </Grid>
             {((editShipmentRequest?.data?.shipmentRequestType==="FVTC") || (editShipmentRequest?.data?.shipmentRequestType==="FWTC")) && (
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Destination</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={editShipmentRequest?.data?.destination}
              onChange={(e) =>
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    destination: e.target.value,
                  },
                })
              }
            />
          </Grid>
              )}
              
          {((editShipmentRequest?.data?.shipmentRequestType==="FVTIMP") || (editShipmentRequest?.data?.shipmentRequestType==="FVTINW") || (editShipmentRequest?.data?.shipmentRequestType==="FVTW") || (editShipmentRequest?.data?.shipmentRequestType==="FVTWCT") || (editShipmentRequest?.data?.shipmentRequestType==="FVTWZF")
           || (editShipmentRequest?.data?.shipmentRequestType==="FWTIMP") || (editShipmentRequest?.data?.shipmentRequestType==="FWTINW") || (editShipmentRequest?.data?.shipmentRequestType==="FWTW") || (editShipmentRequest?.data?.shipmentRequestType==="FWTWCT") || (editShipmentRequest?.data?.shipmentRequestType==="FWTWZF")) && (
          
            <Grid item xs={12} sm={2}>
            <Typography variant="body2">Destination</Typography>
            <Autocomplete
              options={warehouses || []}
              getOptionLabel={(option) =>
                `ID: ${option?.id || ""}, Code: ${option?.code || ""}, Name: ${option?.name || ""}`
              }
              value={selectedWarehouse}
              onChange={(event, newValue) => {
                setSelectedWarehouse(newValue);
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    destination:newValue ? newValue?.name : "",
                  },
                })
              }}
              onOpen={() => retrieveFilteredWarehouseRecords(filterWarehouse)}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label={`${editShipmentRequest?.data?.destination || ""}`}
                />
              )}
              renderTags={() => null}
            />
            {selectedWarehouse && (
              <Box mt={2}>
                <Chip
                  label={`ID: ${selectedWarehouse?.id || ""}`}
                  onDelete={() => {
                    setSelectedWarehouse(null);
                    setEditShipmentRequest({
                      ...editShipmentRequest,
                      data: {
                        ...editShipmentRequest.data,
                        destination: "",
                      },
                    })
                  }}
                  style={{ marginBottom: "5px" }}
                  />
                    <br></br>
                      <Chip
                        label={`Code: ${selectedWarehouse?.code || ""}`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                      <Chip
                        label={`Name: ${selectedWarehouse?.name || ""}`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                      <Chip
                        label={`Contact: ${selectedWarehouse?.warehouseContactPerson?.name || ""}`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                      <Chip
                        label={`Storage Pricing By ${selectedWarehouse?.storagePricingBy || ""}`}
                        style={{ marginBottom: "5px" }}
                      />
                      <br />
                </Box>
            )}
          </Grid>
          )}

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Port Of Loading</Typography>
            <FilterSelect
                 menuType="portsOfLoading"
                 value={editShipmentRequest?.data?.portOfLoading || ""}
                  onChange={(e) => {
                const updatedPOL = e.target.value;
              
                const shouldUpdateDestination =
                  editShipmentRequest?.data?.shipmentRequestType === "FWTC" ||
                  editShipmentRequest?.data?.shipmentRequestType === "FVTC";
              
                const newDestination = shouldUpdateDestination
                  ? determineDestination(
                      selectedSo?.incoterm || "", 
                      updatedPOL,
                      editShipmentRequest?.data?.portOfDischarge
                    )
                  : editShipmentRequest?.data?.destination;
              
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    portOfLoading: updatedPOL,
                    destination: newDestination, 
                  },
                });
              }}
                 fullWidth
               />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Port Of Discharge</Typography>
             <FilterSelect
                      menuType="portsOfDischarge"
                      value={editShipmentRequest?.data?.portOfDischarge || ""}
                      onChange={(e) => {
                const updatedPOD = e.target.value;
              
                const shouldUpdateDestination =
                  editShipmentRequest?.data?.shipmentRequestType === "FWTC" ||
                  editShipmentRequest?.data?.shipmentRequestType === "FVTC";
              
                const newDestination = shouldUpdateDestination
                  ? determineDestination(
                      selectedSo?.incoterm || "", 
                      editShipmentRequest?.data?.portOfLoading,
                      updatedPOD
                    )
                  : editShipmentRequest?.data?.destination; 
              
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    portOfDischarge: updatedPOD,
                    destination: newDestination, 
                  },
                });
              }}
                      fullWidth
                    />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Number Of Cartons</Typography>
            <TextField
              type="number"
              variant="outlined"
              size="small"
              fullWidth
              value={editShipmentRequest?.data?.numberOfCases}
              onWheel={(e) => e.target.blur()}
              onChange={(e) =>
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    numberOfCases: e.target.value,
                    shipmentQuantity:
                      e.target.value *
                      editShipmentRequest?.data?.netWeightPerCase,
                  },
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Net Weight Per Carton</Typography>
            <TextField
              type="number"
              variant="outlined"
              size="small"
              fullWidth
              value={editShipmentRequest?.data?.netWeightPerCase}
              onWheel={(e) => e.target.blur()}
              onChange={(e) =>
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    netWeightPerCase: e.target.value,
                    shipmentQuantity:
                      e.target.value * editShipmentRequest?.data?.numberOfCases,
                  },
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Shipment Quantity</Typography>
            <TextField
              type="number"
              variant="outlined"
              size="small"
              fullWidth
              value={editShipmentRequest?.data?.shipmentQuantity}
              onWheel={(e) => e.target.blur()}
              onChange={(e) =>
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    shipmentQuantity: e.target.value,
                  },
                })
              }
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Shipment Quantity Unit</Typography>
             <FilterSelect
                      menuType="units"
                      value={editShipmentRequest?.data?.shipmentQuantityUnit}
                      onChange={(e) =>
                       setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    shipmentQuantityUnit: e.target.value,
                  },
                })
                      }
                      fullWidth
                    />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Cartons Per Container</Typography>
            <TextField
              type="number"
              variant="outlined"
              size="small"
              fullWidth
              value={editShipmentRequest?.data?.cartonsPerContainer}
              onWheel={(e) => e.target.blur()}
              onChange={(e) =>
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    cartonsPerContainer: e.target.value,
                  },
                })
              }
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Shipment ETD</Typography>
            <TextField
              id="date"
              type="date"
              inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
              InputLabelProps={{
                shrink: true,
              }}
              onKeyDown={(e) => e.preventDefault()}
              variant="outlined"
              size="small"
              fullWidth
              value={
                editShipmentRequest?.data?.shipmentEstimatedTimeOfDeparture
                  ? format(
                      parseISO(
                        editShipmentRequest.data
                          .shipmentEstimatedTimeOfDeparture,
                      ),
                      "yyyy-MM-dd",
                    )
                  : ""
              }
              onChange={(e) =>
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    shipmentEstimatedTimeOfDeparture: e.target.value
                      ? e.target.value + "T00:00:00.000+00:00"
                      : null,
                  },
                })
              }
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Approval Status</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              id="outlined-select-approval-status"
              disabled
              value={editShipmentRequest?.data?.approvalStatus}
            >
            </TextField>
          </Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Approval Date</Typography>
            <TextField
              id="date"
              type="date"
              inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
              InputLabelProps={{
                shrink: true,
              }}
              onKeyDown={(e) => e.preventDefault()}
              variant="outlined"
              size="small"
              fullWidth
              value={
                editShipmentRequest?.data?.approvalDate
                  ? format(
                      parseISO(editShipmentRequest.data.approvalDate),
                      "yyyy-MM-dd",
                    )
                  : ""
              }
              onChange={(e) =>
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    approvalDate: e.target.value
                      ? e.target.value + "T00:00:00.000+00:00"
                      : null,
                  },
                })
              }
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Loading Remark</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={editShipmentRequest?.data?.loadingRemark}
              onChange={(e) =>
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    loadingRemark: e.target.value,
                  },
                })
              }
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Remark</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={editShipmentRequest?.data?.remark}
              onChange={(e) =>
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    remark: e.target.value,
                  },
                })
              }
            />
          </Grid>

          {(editShipmentRequest?.data?.assignedUser && <Grid item xs={12} sm={2}>
            <Typography variant="body2">Assigned To</Typography>
            <Autocomplete
              options={users || []}
              getOptionLabel={(option) =>
                `${
                  option?.name || ""
                }`
              }
              value={selectedUser}
              onChange={(event, newValue) => {
                setSelectedUser(newValue);
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    assignedUser: newValue || {},
                  },
                });
              }}
              onOpen={() => {
                  retrieveUsers();
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              )}
              renderTags={() => null}
            />
          </Grid>)}


          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Status</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              id="outlined-select-status"
              disabled
              value={editShipmentRequest?.data?.status}
            >
            </TextField>
          </Grid>
          {/* 
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Payment Status</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              id="outlined-select-status"
              select
              value={editShipmentRequest?.data?.paymentStatus}
              onChange={(e) =>
                setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    paymentStatus: e.target.value,
                  },
                })
              }
            >
              {status.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          */}

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Record Status</Typography>
            <FilterSelect
                 menuType="recordStatus"
                 value={editShipmentRequest?.data?.recordStatus}
                 onChange={(e) =>
                  setEditShipmentRequest({
                  ...editShipmentRequest,
                  data: {
                    ...editShipmentRequest.data,
                    recordStatus: e.target.value,
                  },
                })
                 }
                 fullWidth
               />
          </Grid>
        </Grid>
        <Stack direction="row" spacing={1} mt={1}>
          <Button
            variant="outlined"
            disabled={isSaving}
            onClick={() =>
              setEditShipmentRequest({
                visible: false,
                data: null,
                index: null,
              })
            }
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={isSaving}
            onClick={async () => {  
              const remainingPurchaseOrderQty = Number(selectedPo?.remainingQuantity) || 0;
              const remainingSalesOrderQty = Number(selectedSo?.remainingQuantity) || 0;
              const shipmentQty = Number(editShipmentRequest?.data?.shipmentQuantity) || 0;   
               const isFromVendor = editShipmentRequest?.data?.shipmentRequestType?.startsWith("FV");
              const isFromWarehouse = editShipmentRequest?.data?.shipmentRequestType?.startsWith("FW");
 const requiresPoLimitCheck =
                isFromVendor || (isFromWarehouse && (editShipmentRequest?.data?.warehouse === "Cross Trades" || editShipmentRequest?.data?.warehouse === "Zafiris Warehouse" ));

                 const endsWithTC   = editShipmentRequest?.data?.shipmentRequestType?.endsWith("TC");
  const endsWithTWCT = editShipmentRequest?.data?.shipmentRequestType?.endsWith("TWCT");
  const endsWithTWZF = editShipmentRequest?.data?.shipmentRequestType?.endsWith("TWZF");
  const endsWithTIMP = editShipmentRequest?.data?.shipmentRequestType?.endsWith("TIMP");

  const requiresSoLimitCheck =
    (endsWithTC || endsWithTWCT || endsWithTWZF || endsWithTIMP) && !!selectedSo;

                  if (
                    requiresPoLimitCheck &&
                    remainingPurchaseOrderQty - editShipmentRequest?.data?.shipmentQuantity < 0
                  ) {
                    toast.error(
                      `Shipment not allowed. Remaining PO quantity after shipment would be ${
                        remainingPurchaseOrderQty - editShipmentRequest?.data?.shipmentQuantity
                      }. Reduce shipment quantity.`,
                    );
                    return;
                  }
    
                  if (
                    requiresSoLimitCheck &&
                    remainingSalesOrderQty - editShipmentRequest?.data?.shipmentQuantity < 0
                  ) {
                   toast.error(
                      `Shipment not allowed. Remaining SO quantity after shipment would be ${remainingSalesOrderQty - addViewStates?.shipmentQuantity}. Reduce shipment quantity.`
                    );
                    return;
                  }

                  setIsSaving(true);
                  
              if (
                editShipmentRequest?.data?.shipmentRequestType?.startsWith("FV") &&
                  (remainingPurchaseOrderQty - shipmentQty) <= 0
              ) {
                const userConfirmed = window.confirm(
                  `⚠️ WARNING: Low Remaining Quantity!\n\n` +
                  `Purchase Order: ${selectedPo?.purchaseOrderNumber}\n` +
                  `Remaining Quantity AFTER this shipment will be: ${remainingPurchaseOrderQty - shipmentQty}\n\n` +
                  `Do you still want to continue with this shipment?`
                );
              
                if (!userConfirmed) {
                  setIsSaving(false);
                  return;
                }
              }
              try {
                const response = await updateShipmentRequestApi(
                  editShipmentRequest.data.id,
                  editShipmentRequest.data,
                );
                toast.success("Shipment request edited successfully.");
                if (mapShipmentRequest) {
                const row = mapShipmentRequest(editShipmentRequest?.data);
                if (rows && setRows) {
                  const idx = rows.findIndex(row => row.id === editShipmentRequest?.data.id);
                
                  if (idx !== -1) {
                    const newRows = [...rows];
                    newRows[idx] = row; 
                    setRows(newRows); 
                  }
                }
              }
                setEditShipmentRequest({
                  visible: false,
                  data: null,
                  index: null,
                });
              } catch (error) {
                toast.error("Something went wrong.");
                console.log(error);
              } finally {
                setIsSaving(false);
              }
            }}
          >
            {isSaving ? <CircularProgress size={20} /> : "Save"}
          </Button>
          <Button
            variant="contained"
            color="error"
            disabled={isSaving}
            onClick={async () => {
              setIsSaving(true);
              editShipmentRequest.data.recordStatus = "PASSIVE";
               try {
                const response = await updateShipmentRequestApi(
                editShipmentRequest.data.id,
                editShipmentRequest.data,
              );
                  toast.success("ShipmentRequest deleted successfully.");
                  window.location.reload();
                  setEditShipmentRequest({
                    visible: false,
                    data: null,
                    index: null,
                  });
                }catch(error){
                  toast.error("Something went wrong.");
                  console.log(error.response.data);
                }finally {
                setIsSaving(false);
              }
            }}
          >
            Delete
          </Button>
        </Stack>
      </Stack>
      </>
            )}
    </>
  );
};

export default EditShipmentRequest;
